"use client";

import { Provider } from "react-redux";
import { useEffect, useState } from "react";
import store from "@/store";
import useAuthInfo from "@/store/auth";

export default function ClientWrapper({ children }) {
  const [isHydrated, setIsHydrated] = useState(false);
  const apiToken = useAuthInfo((state) => state.apiToken);
  const userId = useAuthInfo((state) => state.userId);

  useEffect(() => {
    HydratePage();
  }, []);

  const HydratePage = async () => {
    await useAuthInfo.persist.rehydrate();
    setIsHydrated(true);
  };

  useEffect(() => {
    if (!isHydrated) return;

    const maxAge = 60 * 60 * 24 * 30;

    if (userId) {
      document.cookie = `eyam-user-id=${encodeURIComponent(userId)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    } else {
      document.cookie = "eyam-user-id=; path=/; max-age=0; SameSite=Lax";
    }

    if (apiToken) {
      document.cookie = `eyam-api-token=${encodeURIComponent(apiToken)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    } else {
      document.cookie = "eyam-api-token=; path=/; max-age=0; SameSite=Lax";
    }
  }, [apiToken, isHydrated, userId]);



  return <Provider  store={store}>{children}</Provider>;
}
